import cn from 'classnames'
import React from 'react'

import type { IFieldLayoutProps } from 'components/formKit/types'
import { KitSize } from 'components/uiKit/KitTypes'

import * as s from './FieldBaseLayout.module.scss'

const FieldBaseLayout: React.FC<IFieldLayoutProps> = ({
  children,
  className,
  size = KitSize.M,
  layout = 'horizontal',
  layoutModifiers,
}) => {
  return (
    <div
      className={cn(
        s[layout],
        s[size],
        layoutModifiers?.map((item) => s[item]),
        className,
      )}
    >
      {children}
    </div>
  )
}

export default React.memo(FieldBaseLayout) as typeof FieldBaseLayout
